import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Icon } from '@pwc/pwc-deals-ui';
import {
  postPowerBiPage,
  postPowerBiReport,
} from 'features/contentLibrary/libraryItemService';
import { getReports } from 'features/analyses/powerBiService';
import usePowerBiUrl from 'common/hooks/usePowerBiUrl';
import { Constants } from '@pwc/pwc-deals-web-common';
import { SelectReport } from './SelectReport';
import { SELECT_REPORT_TYPE } from './SelectReportDetail';

export const PowerBiContainer = ({ show, onHide, onAdd }) => {
  const { projectId } = useParams();
  const { t } = useTranslation();

  const emptyPowerBiList = 'noPowerBIMsg';

  const createPBILibraryItem = async (PBIItem, allTabsSelected) => {
    let postPBI;
    if (allTabsSelected) {
      postPBI = await postPowerBiReport(
        projectId,
        PBIItem.reportId,
        PBIItem.name
      );
    } else {
      postPBI = await postPowerBiPage(
        projectId,
        PBIItem.reportId,
        PBIItem.pageName,
        PBIItem.pageDisplayName
      );
    }
    return postPBI;
  };

  return (
    <SelectReport
      show={show}
      workspaceUrl={usePowerBiUrl()}
      onAdd={onAdd}
      onHide={onHide}
      title={t('addPowerBI')}
      pageItemType={{
        report: Constants.LIBRARY_ITEM_TYPES.POWER_BI_REPORT.value,
        reportPage: Constants.LIBRARY_ITEM_TYPES.POWER_BI_REPORT_PAGE.value,
      }}
      createReportLibraryItem={createPBILibraryItem}
      reportIcon={
        // eslint-disable-next-line
        <Icon
          name="powerbi-new"
          width="22"
          className="icon outline icon-orange"
        />
      }
      emptyListMessage={t(emptyPowerBiList)}
      reportType={SELECT_REPORT_TYPE.POWERBI}
      getReports={getReports}
    />
  );
};
